export default {
      id: "pin-c-usage",
      viewBox: "0 0 15 20",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#pin-c",
      toString: function () {
        return this.url;
      }
    }